import { createImageEdits } from '@bestadapted/utility';
import { toBase64 } from './util';
export var fromImageEdits = function (bucketName, prefix) { return function (key, image, resizeBackground, flattenBackground) {
    if (image === void 0) { image = {}; }
    var str = JSON.stringify({
        bucket: bucketName,
        key: key,
        edits: createImageEdits(image, resizeBackground, flattenBackground)
    });
    var enc = toBase64(str);
    return prefix ? prefix + "/" + enc : enc;
}; };
export var CacheDuration;
(function (CacheDuration) {
    CacheDuration[CacheDuration["1 hour"] = 1] = "1 hour";
    CacheDuration[CacheDuration["1 day"] = 24] = "1 day";
    CacheDuration[CacheDuration["7 days"] = 168] = "7 days";
    CacheDuration[CacheDuration["1 month"] = 730] = "1 month";
    CacheDuration[CacheDuration["3.5 months"] = 2555] = "3.5 months";
    CacheDuration[CacheDuration["6 months"] = 4380] = "6 months";
    CacheDuration[CacheDuration["1 year"] = 8760] = "1 year";
})(CacheDuration || (CacheDuration = {}));
//# sourceMappingURL=converter.js.map